import { useQuery } from "@tanstack/react-query";
import { getUserQuestionnaire } from "../../services/users";

const useGetQuestionnaire = (id: number) => {
    return useQuery({
        queryKey: ["questionnaire", id],
        queryFn: () => getUserQuestionnaire(id),
        staleTime: Infinity,
    });
}

export default useGetQuestionnaire;